var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hold-transition login-page"},[_c('div',{staticClass:"login-box"},[_vm._m(0),_c('router-view')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-logo"},[_c('img',{staticClass:"brand-image",staticStyle:{"opacity":".8","height":"70px"},attrs:{"src":require("../../assets/images/logo2.png"),"alt":"CanPay Logo"}}),_vm._v(" Merchant Admin ")])
}]

export { render, staticRenderFns }